export const FormStepWrapper: React.FC<{
  children: React.ReactNode;
  title: string;
  description: string;
}> = ({ children, title, description }) => {
  return (
    <div
      className="max-w-4xl"
      data-loc="case-template-version-form-step-content"
    >
      <div className="rounded-lg border border-gray-200 bg-white">
        <CaseTemplateStepFormHeadline description={description} title={title} />

        <div className="space-y-3 p-5">{children}</div>
      </div>
    </div>
  );
};

const CaseTemplateStepFormHeadline: React.FC<{
  title: string;
  description: string;
}> = ({ title, description }) => {
  return (
    <div className="flex flex-col gap-y-2 border-b border-gray-200 p-5">
      <h2
        className="font-inter-semibold-13px"
        data-loc="case-template-version-step-title"
      >
        {title}
      </h2>
      <p
        className="text-gray-500 font-inter-normal-12px"
        data-loc="case-template-version-step-description"
      >
        {description}
      </p>
    </div>
  );
};
